RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Line = widgets.LineChart = widgets.Chart.extend({
        chartType: RivalIQ.graph.Line,
        className: 'chart line-chart',
        getChartClassName: function () {

            const me = this;
            return _.head(me.getMetricClassNames());
        },

        getTooltip: function () {
            const me = this;

            return {
                title: function (data, index) {
                    const model = me.collection.first();
                    return model.getDomainName(index);
                },

                content: function (data) {

                    let showJustOne = false;
                    if (me.collection.models[0].get('className') === 'landscape-time-usage' && RivalIQ.state.utils.isOnlyCompanySet(me.collection.models[0].get('companySetDescriptor'))) {
                        showJustOne = true;
                    }
                    let collection;
                    if (showJustOne) {
                        collection = new RivalIQ.collections.MetricDefinitions(me.collection.tail().map(function (metric, i) {
                            const value = data[0].value[i];

                            return new RivalIQ.models.MetricDefinition(_.extend(metric.toJSON(), {
                                value: metric.format(value)
                            }));
                        }));
                    } else {
                        collection = new RivalIQ.collections.MetricDefinitions(me.collection.map(function (metric, i) {
                            const value = data[0].value[i];

                            return new RivalIQ.models.MetricDefinition(_.extend(metric.toJSON(), {
                                value: metric.format(value)
                            }));
                        }));
                    }

                    const viewOptions = {
                        collection: collection
                    };

                    return new App.widgets.MetricSummaryTooltip(viewOptions).render().el.outerHTML;
                }
            };
        },

        getChartAttributes: function () {
            const me = this;

            return _.extend({
                width: me.getProp('width'),
                height: me.getProp('height')
            }, {
                tooltip: (me.getTooltip ? me.getTooltip() : null),
                showComparePeriod: Boolean(me.getProp('showComparePeriod'))
            }, widgets.Chart.prototype.getChartAttributes.apply(me, arguments));
        }
    });

    widgets.MetricLineChartWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        title: function () {
            const me = this;
            return me.metrics.invoke('getName').join(', ');
        },
        view: Line,
        processProps: function (props) {
            const me = this;

            if (props.lineChartDimensions) {

                if (me.metrics) {
                    me.metrics = new RivalIQ.collections.MetricDefinitions(me.metrics.map(function (metric) {
                        let dimensions = _.difference(metric.get('dimensions'), _.values(RivalIQ.enums.timePeriod.interval));
                        dimensions = _.union(dimensions, props.lineChartDimensions);
                        return metric.build({
                            dimensions: dimensions,
                            interval: props.interval
                        }, {
                            clobberDimensions: true
                        });
                    }));
                } else {

                    if (props.useAutoTimeInterval) {
                        props.lineChartDimensions = [RivalIQ.metric.timePeriod.getDefaultInterval(props.timePeriod)];
                    }

                    let metric = RivalIQ.metric.pin(RivalIQ.metric.build(props, props.metrics[0]));
                    metric = RivalIQ.metric.build(metric, {
                        dimensions: props.lineChartDimensions
                    });

                    me.metrics = new RivalIQ.collections.MetricDefinitions([metric]);
                }

            } else {
                props = widgets.Chart.buildMetrics(me, props);
            }

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_LINE_CHART, widgets.MetricLineChartWidget);
});
